export const validateEmail = (email) => {
    if (!email) {
        return "Het e-mailveld is verplicht!";
    }

    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return "Het e-mailveld is geen geldig adres!";
    }

    return null;
};
  
export const validateForm = (firstName, lastName, email, message, privacy, phone) => {
    if (!firstName || !lastName || !email || !message || !privacy || !phone) {
        return "Alle velden zijn verplicht";
    }

    return validateEmail(email);
};